import {
  ApiAppointmentStatus,
  AppointmentStatus,
} from '../../types/interfaces/IAppointment';

const toUiStatusMap: Record<string, AppointmentStatus> = {
  scheduled: 'scheduled',
  confirmed: 'confirmed',
  'in-waiting-room': 'inWaitingRoom',
  inWaitingRoom: 'inWaitingRoom',
  'in-progress': 'inProgress',
  inProgress: 'inProgress',
  attended: 'attended',
  absent: 'absent',
  cancelled: 'cancelled',
};

const toApiStatusMap: Record<string, ApiAppointmentStatus> = {
  scheduled: 'scheduled',
  confirmed: 'confirmed',
  inWaitingRoom: 'inWaitingRoom',
  'in-waiting-room': 'inWaitingRoom',
  inProgress: 'inProgress',
  'in-progress': 'inProgress',
  attended: 'attended',
  absent: 'absent',
  cancelled: 'cancelled',
};

export function normalizeAppointmentStatus(
  status?: string | null
): AppointmentStatus | undefined {
  if (!status) {
    return undefined;
  }

  return toUiStatusMap[status] || undefined;
}

export function toApiAppointmentStatus(
  status?: string | AppointmentStatus | ApiAppointmentStatus
): ApiAppointmentStatus | undefined {
  if (!status) {
    return undefined;
  }

  return toApiStatusMap[status] || undefined;
}
